import React from 'react';
import * as Sentry from '@sentry/browser';

import { Link } from '@neptune/shared/venus-ui';

import { ErrorPage } from './ErrorPage';

export const UnavailableErrorPage = () => {
  React.useEffect(() => {
    Sentry.addBreadcrumb({
      level: 'error',
      category: 'lazy-loading',
      message: 'Error loading component',
    });
  }, []);

  return (
    <ErrorPage>
      <ErrorPage.Message>The page you are trying to access is unavailable now.</ErrorPage.Message>
      <ErrorPage.Footer>
        Please <Link onClick={() => window.location.reload()}>reload page</Link> to continue.
      </ErrorPage.Footer>
    </ErrorPage>
  );
};
